import { ReactNode } from "react"

interface PageDialogProps {
   // TODO modalId: string
   isOpen: boolean
   onClose: () => void
   children: ReactNode
}

export function PageDialog({ isOpen, onClose, children }: PageDialogProps) {
   return (
      <dialog className={`modal ${isOpen ? "modal-open" : ""} p-0 m-0`}>
         <div className="modal-box max-w-2xl m-0 p-0 ">
            <button onClick={onClose} className="btn btn-sm btn-circle absolute right-2 top-2 z-99">
               ✕
            </button>
            <div
               className="container mx-auto 
               bg-white px-3 py-6 sm:p-8 lg:p-10"
            >
               {children}
            </div>
         </div>
         <div className="modal-backdrop" onClick={onClose}></div>
      </dialog>
   )
}
